import { request } from './client';

// Admin list with optional filters (rating, bookId, search).
export const apiAdminGetReviews = ({ page = 1, limit = 20, rating, bookId, search } = {}) => {
  const params = new URLSearchParams({ page, limit });
  if (rating) params.set('rating', rating);
  if (bookId) params.set('bookId', bookId);
  if (search) params.set('search', search);
  return request(`/reviews/admin/all?${params.toString()}`);
};

// Same DELETE endpoint that owners use — backend allows admin role to delete any review.
export const apiDeleteReview = (id) => request(`/reviews/${id}`, { method: 'DELETE' });
